import PubSub from "underpub-js";
import gsap from 'gsap';

var HeaderNavigationDropdown = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-HeaderNavigationDropdown',
		isToggled: false,
	};

	$.extend(true, this.options, options);

};

HeaderNavigationDropdown.prototype.init = function() {

	var self = this;

	self.$underline = self.options.$el.find(`.${self.options.baseClass}__underline`);
	self.$dropdown = self.options.$el.find(`.${self.options.baseClass}__subitems`);
	self.$dropdownItems = self.options.$el.find(`.${self.options.baseClass}__subitem`);

	self.initAnimation();

	PubSub.subscribe('HeaderNavigationDropdown:toggleIfChild', data => {
		const $parent = data.$parent;
		if (self.options.$el.closest($parent).length) {
			self.toggleOn();
		}
		else {
			self.toggleOff();
		}
	});

};

HeaderNavigationDropdown.prototype.initAnimation = function() {

	let self = this;

	self.animationTl = gsap
		.timeline({
			paused: true,
			reversed: true,
		})
		.set(self.$dropdownItems, {
			zIndex: 1,
			visibility: "visible",
		})
		.to(self.$underline, {
			duration: 0.36,
			right: 0,
		})
		.to(self.$dropdownItems, {
			duration: 0.3,
			stagger: 0.1,
			opacity: 1,
			y: 0,
		}, "<+=0.08")

};

HeaderNavigationDropdown.prototype.toggle = function () {
	const self = this;
	!self.options.isToggled ? self.toggleOn() : self.toggleOff();
	self.toggleState();
};

HeaderNavigationDropdown.prototype.toggleState = function () {
	const self = this;
	self.options.isToggled = !self.options.isToggled;
};

HeaderNavigationDropdown.prototype.toggleOn = function (speed = 1) {
	const self = this;
	self.animationTl.timeScale(speed).play();
};

HeaderNavigationDropdown.prototype.toggleOff = function (speed = 1.4) {
	const self = this;
	self.animationTl.timeScale(speed).reverse();
};

export default HeaderNavigationDropdown;
